module.exports = "/_next/static/images/quack-0014030cbec2ecadb2cc5fdc12867b83.svg";